import { render, staticRenderFns } from "./AddTheme.vue?vue&type=template&id=451eb83b&"
import script from "./AddTheme.vue?vue&type=script&lang=js&"
export * from "./AddTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports